import { graphql } from "@opensea/graphql"
import { RarityBadgeFragment } from "../../../../../components/RarityBadge/RarityBadge.fragment"
import { readItemHighestTraitFloorFragment } from "./readItemHighestTraitFloor.fragment"

export const ListingFlowItemsTableRowFragment = graphql(
  `
    fragment ListingFlowItemsTableRow on Item {
      id
      tokenId
      name
      imageUrl
      isFungible
      lastSale {
        token {
          unit
          symbol
        }
      }
      bestOffer {
        id
        pricePerItem {
          token {
            unit
            symbol
          }
        }
      }
      chain {
        listingCurrency {
          symbol
        }
      }
      collection {
        id

        floorPrice {
          id
          pricePerItem {
            token {
              unit
              symbol
            }
          }
        }
        fees {
          openseaFee {
            feeBasisPoints
          }
          totalCreatorFee {
            feeBasisPoints
          }
        }
      }
      bestListing {
        pricePerItem {
          token {
            unit
            symbol
          }
        }
      }
      ...RarityBadge
      ...readItemHighestTraitFloor
    }
  `,
  [RarityBadgeFragment, readItemHighestTraitFloorFragment],
)
